export default __webpack_public_path__ + "static/media/11.a3b5d752.jpg";